import $ from 'jquery';
import 'isotope-layout/dist/isotope.pkgd.min';

$( document ).ready(function() {
    var sortingContainer = $(".isotope-container-sorting");
    sortingContainer.isotope({
        filter: '*',
        layoutMode: 'fitRows',
        gutter: 10
    });

    $(".isotope-sorting > *").on('click', function () {
        $(".isotope-sorting > *").removeClass('select');
        var $element = $(this);
        var data = $element.data('sort');
        $element.addClass("select");
        if (data != undefined) {
            sortingContainer.isotope({filter: data});
        }
    })

    var partnerAnchor = $(location).attr('hash');
    partnerAnchor = partnerAnchor.replace('#', '');
    if (partnerAnchor) {
        $('#partner-modal-' + partnerAnchor).modal('show');
    }
});

